// Human friendly Italian labels for permission keys, so a non technical
// operator understands what an API client is allowed to do.

// Group -> { label, noun, order }. Lower order shows first (integration
// relevant groups on top).
export const GROUP_LABELS = {
  products: { label: 'Prodotti', noun: 'i prodotti', order: 1 },
  stores: { label: 'Negozi', noun: 'i negozi', order: 2 },
  rag: { label: 'Knowledge base', noun: 'i documenti', order: 3 },
  ai: { label: 'Assistente AI', noun: 'l\'AI', order: 4 },
  analytics: { label: 'Statistiche', noun: 'le statistiche', order: 5 },
  users: { label: 'Utenti', noun: 'gli utenti', order: 6 },
  roles: { label: 'Ruoli', noun: 'i ruoli', order: 7 },
  permissions: { label: 'Permessi', noun: 'i permessi', order: 8 },
  privacy: { label: 'Privacy (GDPR)', noun: 'la privacy', order: 9 },
  settings: { label: 'Impostazioni', noun: 'le impostazioni', order: 10 },
  clients: { label: 'Client API', noun: 'i client API', order: 11 },
  logs: { label: 'Log', noun: 'i log', order: 12 },
  audit: { label: 'Audit', noun: 'l\'audit', order: 12 },
  'auth-audit': { label: 'Audit accessi', noun: 'gli accessi', order: 12 },
  sessions: { label: 'Sessioni', noun: 'le sessioni', order: 13 },
  security: { label: 'Sicurezza', noun: 'la sicurezza', order: 13 },
  system: { label: 'Sistema', noun: 'il sistema', order: 14 },
  me: { label: 'Profilo', noun: 'il profilo', order: 15 }
};

// Groups worth suggesting for external integrations (POS, e-commerce).
export const INTEGRATION_GROUPS = ['products', 'stores'];

// Verb per action suffix; combined with the group noun.
const ACTION_VERB = {
  read: 'Vedere',
  create: 'Creare',
  update: 'Modificare',
  delete: 'Eliminare',
  upload: 'Caricare',
  export: 'Esportare',
  manage: 'Gestire',
  rollback: 'Ripristinare',
  revoke: 'Revocare',
  rotate: 'Rigenerare il segreto di'
};

// Fully custom labels where the verb+noun rule does not read well.
const SPECIAL = {
  'users:assign-role': 'Assegnare i ruoli agli utenti',
  'ai:chat': 'Usare l\'assistente AI',
  'ai:configure': 'Configurare l\'assistente AI',
  'ai:test': 'Provare l\'assistente AI (playground)',
  'ai:feedback': 'Inviare feedback sulle risposte AI',
  'system:health': 'Vedere lo stato del sistema',
  'system:maintenance': 'Attivare la modalità manutenzione',
  'sessions:revoke': 'Forzare il logout delle sessioni',
  'security:manage': 'Gestire la sicurezza (ban IP, kill switch)'
};

export function friendlyScope(key) {
  if (SPECIAL[key]) return SPECIAL[key];
  const [group, action] = key.split(':');
  const g = GROUP_LABELS[group];
  const verb = ACTION_VERB[action];
  if (g && verb) return `${verb} ${g.noun}`;
  return key; // fallback to the raw key
}

export function groupLabel(group) {
  return (GROUP_LABELS[group] && GROUP_LABELS[group].label) || group;
}

export function groupOrder(group) {
  return (GROUP_LABELS[group] && GROUP_LABELS[group].order) || 99;
}
